/**
 * Skinny banner visual tokens.
 * TODO: Replace with Formation design tokens once the design team
 *       provides an updated token mapping for this component.
 */

/** Tablet breakpoint at which the banner switches from mobile to tablet layout. */
export const SKINNY_BANNER_TABLET_MIN_WIDTH = 768;

export const TEXT_COLOR = "#ffffff"; // globals.$white → contentOnDark
export const BORDER_COLOR = "#ffffff"; // globals.$white
export const BORDER_RADIUS = 12;
export const BOX_SHADOW = "0 0 4px 0 #0a0a0a40";
export const BANNER_HEIGHT = 50;
export const LOGO_SIZE = 60;
export const MOBILE_TEXT_FONT_SIZE = 14;
export const TABLET_TEXT_FONT_SIZE = 16;
export const MOBILE_PADDING_RIGHT = 16;
export const TABLET_PADDING_X = 16;
export const CONTENT_GAP = 8;

/**
 * Text weights. The banner never sets a font family — typography is inherited
 * from the host so the kit stays brand-agnostic.
 */
export const REGULAR_FONT_WEIGHT = 400;
export const BOLD_FONT_WEIGHT = 700;
